import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { AsincronoService } from 'src/app/shared/services/asincrono.service';
import { InactivityService } from 'src/app/shared/services/inactivity.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
//import { ModalInfoMfaComponent } from 'src/app/components/modal-info-mfa/modal-info-mfa.component';
//import { MatDialog } from '@angular/material/dialog';
//import * as Auth from 'aws-amplify/auth';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {

  @ViewChild('stepper') stepper!: MatStepper;
  private _formBuilder = inject(FormBuilder);

  firstFormGroup = this._formBuilder.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this._formBuilder.group({
    secondCtrl: ['', Validators.required],
  });
  isLinear = false;

  hasServiceErrors$ = this.asincronoService.hasServiceErrors$;

  constructor(
    public alertService: AlertService,
    private _sessionService: SessionService,
    private _usuarioService: UsuariosService,
    private inactivityService: InactivityService,
    private spinner: NgxSpinnerService,
    private readonly route: ActivatedRoute,
    private readonly titleService: Title,
    private router: Router,
    private asincronoService: AsincronoService,
    //private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle(this.route.snapshot.data['title']);
    setInterval(() => {
      if (!this.stepper) return;
      const nextIndex = (this.stepper.selectedIndex + 1) % this.stepper._steps.length;
      this.stepper.selectedIndex = nextIndex;
    }, 4000); // Change step every 4 seconds
    if(!this._sessionService.getOrganization()){
      this.router.navigate(['/organizacion']);
    } else {
      this.spinner.show();
      this._usuarioService.getAccessForUser(this._sessionService.getUserInfo().email)
        .subscribe(
          (data) => {
            this._sessionService.setUserAccess(data.availableAccess);
            this._sessionService.setUSerProfileList(data.profilesList);
            //this.validacionMFA();
            
            this.spinner.hide();
          },
          ({ error }) => {
            this.alertService.error(error.message);
          }
        );
    }

  }

  /*async validacionMFA(){
    if(!(await this.validateTOTP())) {
      this.openModal();
    }
  }

  async validateTOTP(): Promise<boolean> {
    const mfaConfig = await Auth.fetchMFAPreference();
    if(mfaConfig?.preferred == 'TOTP') {
      return true;
    }
    return false;
  }

  openModal() {
    this.dialog.open(ModalInfoMfaComponent);
  }*/

}
